import { SET_STAY } from '../helpers/constants/actionsConstants';

import type { SetStayAction } from './types';

type StayPayload = {
  adults: number | null;
  childrenAges: number[];
};

const setStay = ({ adults, childrenAges }: StayPayload): SetStayAction => ({
  type: SET_STAY,
  payload: {
    adults,
    childrenAges,
  },
});

export default setStay;
